import { useEffect, useState } from 'react';
import { useThemeContext } from '../../../context/ThemeContext';

export const useNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { isDarkMode, toggleTheme } = useThemeContext();
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    handleClose();
  };

  const menuItems = [
    { label: 'Início', id: 'home' },
    { label: 'Sobre', id: 'about' },
    { label: 'Habilidades', id: 'skills' },
    { label: 'Projetos', id: 'projects' },
    { label: 'Formação', id: 'education' },
    { label: 'Certificações', id: 'certifications' },
    { label: 'Contato', id: 'contact' },
  ];

  const isMenuOpen = Boolean(anchorEl);

  return {
    isScrolled,
    isDarkMode,
    toggleTheme,
    anchorEl,
    isMenuOpen,
    menuItems,
    handleMenu,
    handleClose,
    scrollToSection,
  };
};
